(function () {
    var defaults = {
        url: false,
        callback: false,
        target: false,
        duration: 120,
        on: 'mouseover',
        touch: true,
        onZoomIn: false,
        onZoomOut: false,
        magnify: 1
    };

    function extend(target, source) {
        for (var key in source) {
            if (source.hasOwnProperty(key)) {
                target[key] = source[key];
            }
        }
        return target;
    }

    function Zoom(target, source, img, magnify) {
        var targetHeight,
            targetWidth,
            sourceHeight,
            sourceWidth,
            xRatio,
            yRatio,
            offset,
            position = window.getComputedStyle(target).position;

        target.style.position = /(absolute|fixed)/.test(position) ? position : 'relative';
        target.style.overflow = 'hidden';
        img.style.width = img.style.height = '';

        img.classList.add('zoomImg');
        img.style.position = 'absolute';
        img.style.top = 0;
        img.style.left = 0;
        img.style.opacity = 0;
        img.style.width = img.width * magnify + 'px';
        img.style.height = img.height * magnify + 'px';
        img.style.border = 'none';
        img.style.maxWidth = 'none';
        img.style.maxHeight = 'none';
        target.appendChild(img);

        return {
            init: function () {
                targetWidth = target.offsetWidth;
                targetHeight = target.offsetHeight;

                if (source === target) {
                    sourceWidth = targetWidth;
                    sourceHeight = targetHeight;
                } else {
                    sourceWidth = source.offsetWidth;
                    sourceHeight = source.offsetHeight;
                }

                xRatio = (img.width - targetWidth) / sourceWidth;
                yRatio = (img.height - targetHeight) / sourceHeight;

                offset = source.getBoundingClientRect();
            },
            move: function (e) {
                var left = (e.pageX - offset.left),
                    top = (e.pageY - offset.top);

                top = Math.max(Math.min(top, sourceHeight), 0);
                left = Math.max(Math.min(left, sourceWidth), 0);

                img.style.left = (left * -xRatio) + 'px';
                img.style.top = (top * -yRatio) + 'px';
            }
        };
    }

    function zoom(options) {
        var settings = extend({}, defaults);
        extend(settings, options || {});

        return this.forEach(function (source) {
            var target = settings.target || source,
                img = document.createElement('img'),
                clicked = false,
                touched = false;

            if (!settings.url) {
                var srcElement = source.querySelector('img');
                if (srcElement) {
                    settings.url = srcElement.getAttribute('data-src') || srcElement.currentSrc || srcElement.src;
                }
                if (!settings.url) {
                    return;
                }
            }

            img.onload = function () {
                var zoom = Zoom(target, source, img, settings.magnify);

                function start(e) {
                    zoom.init();
                    zoom.move(e);
                    img.style.transition = `opacity ${settings.duration}ms`;
                    img.style.opacity = 1;
                    if (typeof settings.onZoomIn === 'function') settings.onZoomIn.call(img);
                }

                function stop() {
                    img.style.opacity = 0;
                    if (typeof settings.onZoomOut === 'function') settings.onZoomOut.call(img);
                }

                if (settings.on === 'mouseover') {
                    zoom.init();
                    source.addEventListener('mouseenter', start);
                    source.addEventListener('mouseleave', stop);
                    source.addEventListener('mousemove', zoom.move);
                }

                if (settings.touch) {
                    source.addEventListener('touchstart', function (e) {
                        e.preventDefault();
                        if (touched) {
                            touched = false;
                            stop();
                        } else {
                            touched = true;
                            start(e.touches[0]);
                        }
                    });

                    source.addEventListener('touchmove', function (e) {
                        e.preventDefault();
                        zoom.move(e.touches[0]);
                    });

                    source.addEventListener('touchend', function (e) {
                        e.preventDefault();
                        if (touched) {
                            touched = false;
                            stop();
                        }
                    });
                }

                if (typeof settings.callback === 'function') {
                    settings.callback.call(img);
                }
            };

            img.setAttribute('role', 'presentation');
            img.alt = '';
            img.src = settings.url;
        });
    }

    Element.prototype.zoom = function (options) {
        return zoom.call([this], options);
    };

    NodeList.prototype.zoom = function (options) {
        return zoom.call(this, options);
    };
})();